import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.css'],
})
export class LocationsComponent {
  constructor(private router: Router, private route: ActivatedRoute) {}
  
  navigate(page: string) {
    this.router.navigate([page], { relativeTo: this.route });
  }
  
}
